/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_Check_NowInputs */

const en_mobile_ota_check_now = /** @type {(inputs: Mobile_Ota_Check_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check for update`)
};

const es_mobile_ota_check_now = /** @type {(inputs: Mobile_Ota_Check_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar actualización`)
};

/**
* | output |
* | --- |
* | "Check for update" |
*
* @param {Mobile_Ota_Check_NowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_check_now = /** @type {((inputs?: Mobile_Ota_Check_NowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_Check_NowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_check_now(inputs)
	return en_mobile_ota_check_now(inputs)
});